document.querySelectorAll('.MapFindAddress__map').forEach((el) => {
    const inputs = el.parentElement.querySelectorAll('.MapFindAddress__form input');
    const cordsArr = JSON.parse(el.dataset.cords);
    let myMap, myPlacemark;

    try {
        ymaps.ready(function () {
            myMap = new ymaps.Map(el, {
                center: cordsArr,
                zoom: 9,
                controls: ['zoomControl'],
            });

            myMap.events.add('click', function (e) {
                var coords = e.get('coords');

                // Если метка уже создана – просто передвигаем ее.
                if (myPlacemark) {
                    myPlacemark.geometry.setCoordinates(coords);
                }
                // Если нет – создаем.
                else {
                    myPlacemark = getMapPontSimple(coords);
                    myPlacemark.options.set({ draggable: true });
                    myMap.geoObjects.add(myPlacemark);
                    // Слушаем событие окончания перетаскивания на метке.
                    myPlacemark.events.add('dragend', function () {
                        getAddress(myPlacemark.geometry.getCoordinates());
                    });
                }
                getAddress(coords);
            });


        });
    } catch (e) {
        console.warn(e);
    }


    function getAddress(coords) {
        myPlacemark.properties.set('iconCaption', 'поиск...');
        ymaps.geocode(coords).then(function (res) {
            var firstGeoObject = res.geoObjects.get(0);
            const city = firstGeoObject.getLocalities().join(', ');
            const street = firstGeoObject.getThoroughfare() || firstGeoObject.getPremise();
            const house = firstGeoObject.getPremiseNumber();

            [street, house].forEach((value, i) => {
                inputs[i].value = value || '';
            })

            console.log({ city, street, house }, firstGeoObject.getAddressLine());
            myPlacemark.properties
                .set({
                    hintContent: firstGeoObject.getAddressLine(),
                });
        });
    }

    function getMapPontSimple(cords, name) {
        const myPlacemarkWithContent = new ymaps.Placemark(cords, {
            iconContent: name,
        }, {
            iconLayout: 'default#image',
            iconImageHref: '/img/map-point.svg',
            iconImageSize: [33, 35],
            iconImageOffset: [-16.5, -35],
            iconContentOffset: [8, 4],
        });

        return myPlacemarkWithContent;
    }

});
